import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ParadigmaModal from "../../../components/ParadigmaModal/ParadigmaModal.js"
import api from "../../../api";
import SubgroupFormFields from "./SubgroupFormFields.js";

class Delete extends Component {
    constructor(props) {
        super(props);
        this.state = {
            padre_id: null,
        };
    }

    static propTypes = {
        onSubmit: PropTypes.func.isRequired,
        id: PropTypes.func.isRequired,
    }

    setSelects(data) {
        this.setState({
            padre_id: data.padre_id,
        });
    }

    ResetForm() {
        this.setState({
            padre_id: null,
        });
    }

    render() {
        return (
            <ParadigmaModal
                getUrl={api.usuarios.subgrupos.delete}
                postUrl={api.usuarios.subgrupos.delete}
                onSubmit={() => this.props.onSubmit()}
                id={this.props.id}
                successMessage={"El Subgrupo ha sido eliminado con éxito."}
                notAllowedMessage={"El Subgrupo no puede ser eliminado ya que se encuentra en uso por Usuarios del sistema."}
                missingIdMessage={"Debe seleccionar una fila."}
                title={"Eliminar Subgrupo"}
                buttonTitle={"Eliminar Subgrupo"}
                buttonIcon={"fa fa-trash fa-lg"}

                saveButton={true}
                closeButton={true}
                danger={true}
                buttonClass={"btn-danger"}
                saveButtonLabel={"Eliminar"}
                className={"ui-modal-dialog ui-modal-md"}
                onGotData={(data) => this.setSelects(data)}
                onClose={() => this.ResetForm()}
            >
                <div className="ui-form">
                    <div className="ui-alert ui-alert-danger">
                        <i className="ti ti-trash" aria-hidden="true"></i>
                        Se eliminará el subgrupo seleccionado.
                    </div>
                    <SubgroupFormFields
                        disabled={true}
                        grupoFieldName={""}
                        padreId={this.state.padre_id}
                        onGrupoChange={(data) => this.setState({ padre_id: (data != null ? data.pk : 0) })} />
                </div>
            </ParadigmaModal>
        );
    }
}

export default Delete;



// WEBPACK FOOTER //
// ./src/views/Usuarios/Subgrupos/Delete.js